import http from "@/api/http";

/**
 * Fetch permissions of the signed-in agent.
 * @return {Promise<Object>}
 */
export const fetchRolesAndPermissions = async () => {
  return await http.get("/api/agent/permissions");
};
